"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.topBlockTemplate = void 0;
var tslib_1 = require("tslib");
var top_block_dot_1 = (0, tslib_1.__importDefault)(require("./top-block.dot"));
var topBlockTemplate = top_block_dot_1.default.default ? top_block_dot_1.default.default : top_block_dot_1.default;
exports.topBlockTemplate = topBlockTemplate;
//# sourceMappingURL=index.js.map